import {TrmzFileDTO} from "@web-libs/features/files/trmz-file/api/trmz-file.types";
import {Information} from "@web-libs/features/information/domain/information.types";
import {TrmzFileDTOConverter} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";
import {Page, unwrapPage} from "@web-libs/core/pagination/api/pagination.functions";

export type InformationDTO = {
    id: string;
    title: string;
    subtitle?: string;
    description: string;
    titleImage?: TrmzFileDTO;
    informationFiles?: TrmzFileDTO[];
    informationMedia?: TrmzFileDTO[];
    tags?: TagDTO[];
    creator?: UserDTO;
    publishDate?: string;
}

export type TagDTO = {
    id: string;
    name: string;
}

export type UserDTO = {
    id: string;
    firstName: string;
    lastName: string;
}

export function parseInformationDTO(dto:InformationDTO, trmzFileConverter: TrmzFileDTOConverter): Information {
    return {
        id: dto.id,
        title: dto.title,
        description: dto.description ?? "",
        media: dto.informationMedia ? dto.informationMedia.map(medium => trmzFileConverter.parseDTOToMedium(medium)) : [],
        files: dto.informationFiles ? dto.informationFiles.map(file => trmzFileConverter.parseDTOToFile(file)) : [],
        tags: dto.tags ? dto.tags.map(tag => tag.name) : [],
        subtitle: dto.subtitle,
        titleImage: dto.titleImage ? trmzFileConverter.parseDTOToFile(dto.titleImage) : undefined,
        author: dto.creator ? `${dto.creator.firstName} ${dto.creator.lastName}` : undefined,
        pusblishedAt: dto.publishDate ? new Date(dto.publishDate) : undefined
    }
}

export function parseInformationDTOs(dtos:InformationDTO[], trmzFileConverter: TrmzFileDTOConverter): Information[] {
    return dtos.map(dto => parseInformationDTO(dto, trmzFileConverter));
}

export function parseInformationPage(page: Page<InformationDTO>, trmzFileConverter: TrmzFileDTOConverter): Information[] {
    const dtos = unwrapPage(page);
    return parseInformationDTOs(dtos, trmzFileConverter);
}
